import React, { createContext, useContext, useState, useEffect } from 'react';
import { subscriptionService } from '../services/subscriptionService';

const CreditsEnabledContext = createContext({ creditsEnabled: true, loading: true });

export const CreditsProvider = ({ children }) => {
  const [creditsEnabled, setCreditsEnabled] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    subscriptionService.getCreditBalance().then(result => {
      if (result.success) {
        setCreditsEnabled(result.data.credits_enabled !== false);
      }
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  }, []);

  return (
    <CreditsEnabledContext.Provider value={{ creditsEnabled, loading }}>
      {children}
    </CreditsEnabledContext.Provider>
  );
};

export const useCreditsEnabled = () => useContext(CreditsEnabledContext);
